<div class="flex flex-col gap-4">

  <div>
    <p-menu #createMenu [popup]="true" [model]="createMenuItems()"></p-menu>
    <button type="button" pButton icon="pi pi-list" label="Create" (click)="createMenu.toggle($event)"></button>
  </div>


@if (authService.hasRole("crisis")) {
<p-card header="Incident Reports to be Linked">
  <app-incident-table2 
  [incidents]="unlinkedReports()" 
  view="report"
  [actions]="unlinkedReportActions"
  (rowClick)="onUnlinkedReportClick($event)"
  class="data-table-clickable"
  stateKey="unlinked-reports"
  [loading]="linkReportsLoading()"
  [useTransitionButton]="false"      
> </app-incident-table2>
</p-card>

<p-card>
  <ng-template pTemplate="header">
    <p-select [options]="incidentLists" [(ngModel)]="selectedIncidentList" optionLabel="name" (ngModelChange)="loadIncidents()"></p-select>
  </ng-template>

  <app-incident-table2 
  [incidents]="incidents()"
  [actions]="openIncidentActions"
  [useTransitionButton]="true"
  [showSeverityImpact]="showSeverityImpact()"
  (rowClick)="onOpenIncidentClick($event)"
  class="data-table-clickable"
  stateKey="open-incidents"
  [loading]="incidentsLoading()"
  ></app-incident-table2>

</p-card>

}

@if (!authService.hasRole("crisis")) {
  <p-card header="My Submitted Reports">
    <app-incident-table2
    [incidents]="myIncidentReports()"
    [actions]="myReportActions"
    view="report"
    stateKey="my-incident-reports"
    [loading]="myReportsLoading()"
    [useTransitionButton]="false"
    ></app-incident-table2>
  </p-card>
}

</div>
